/** Memory Game
 *  Credits to https://github.com/sandraisrael/Memory-Game-fend and 
 *  https://scotch.io/tutorials/how-to-build-a-memory-matching-game-in-javascript
 */
(function($) {

    if (!document.querySelector('.carousel-memory-game')) {
        return;
    }

    var card = document.getElementsByClassName('memory-card');
    var cards = Array.prototype.slice.call(card);
    var nCards = 12;

    var deck = document.getElementById('card-deck');
    var counter = document.getElementById('moves');
    var stars = document.querySelectorAll('#stars li');
    var closeIcon = document.getElementById('close');
    var restart = document.getElementById('restart');
    var playAgain = document.getElementById('play-again');
    var openedCards = [];
    var matchedCard = document.getElementsByClassName('match');
    var moves = 0;
    var interval;
    var seconds = 0,
        minutes = 0;
    var timer = document.getElementById('timer');
    var modal = document.getElementById('popup');

    // Translatable text
    var minutesText = mousyLocalize.minutesText;
    var secondsText = mousyLocalize.secondsText;


    // Create event handler
    document.addEventListener('click', function (event) {
        if (!event.target.closest('.memory-card')) {
            return;
        }
        
        var card = event.target.closest('.memory-card');
        card.classList.toggle('open');
        card.classList.toggle('show');
        card.classList.toggle('disabled');
        checkCardMatching(card);
        congratulations();
    }, false);

    restart.addEventListener('click', startGame, false);

    playAgain.addEventListener('click', function() {
        modal.classList.remove('show');
        document.getElementById('star-rating').innerHTML = '';
        startGame();
    }, false);

    /* jshint ignore:start */
    function startGame(stopSlider = true) {
        openedCards = [];
        var shuffledCards = shuffle(cards);
        for (var i = 0; i < shuffledCards.length; i++) {
            deck.innerHTML = '';
            [].forEach.call(shuffledCards, function(item) {
                deck.appendChild(item);
            });
            cards[i].classList.remove('show', 'open', 'match', 'disabled');
        }    

        // reset moves
        moves = 0;
        counter.innerHTML = moves;

        // reset star rating
        for (var i = 0; i < stars.length; i++) {
            stars[i].style.visibility = 'visible';
        }

        // reset timer
        seconds, minutes = 0;
        timer.innerHTML = '0 ' + minutesText + ' 0 ' + secondsText;
        clearInterval(interval);   

        if (stopSlider) {
          // pause the slider    
          $('#slider').carousel('pause');
        }
    }

    function checkCardMatching(card) {
        openedCards.push(card);
        var len = openedCards.length;

        if (len === 2) {
            moveCounter();

            if (openedCards[0].type === openedCards[1].type) {
                matched();
            } else {
                unmatched();
            }
        }
    }

    // for matching cards
    function matched() {
        openedCards[0].classList.add('match');
        openedCards[1].classList.add('match');
        openedCards[0].classList.remove('show', 'open');
        openedCards[1].classList.remove('show', 'open');
        openedCards = [];
    }

    // for unmatching cards
    function unmatched() {
        openedCards[0].classList.add('unmatched');
        openedCards[1].classList.add('unmatched');

        disable();

        setTimeout(function() {
            openedCards[0].classList.remove('show', 'open', 'unmatched');
            openedCards[1].classList.remove('show', 'open', 'unmatched');
            enable();
            openedCards = [];
        }, 1100);
    }

    // disable cards temporarily
    function disable() {
        Array.prototype.filter.call(cards, function(card) {
            card.classList.add('disabled');
        });
    }

    // enable cards and disable matched cards
    function enable() {
        Array.prototype.filter.call(cards, function(card) {
            card.classList.remove('disabled');
            for (var i = 0; i < matchedCard.length; i++) {
                matchedCard[i].classList.add('disabled');
            }
        });
    }

    function moveCounter() {
        moves++;
        counter.innerHTML = moves;

        // start timer on first move
        if (moves == 1) {
            seconds = 0;
            minutes = 0;
            startTimer();      
            $('#slider').carousel('pause');
        }

        // set star rating
        if (moves > (nCards * 0.5) && moves <= (nCards * 0.75) ) {
            for (var i = 0; i < 3; i++) {
                if (i > 1) {
                    stars[i].style.visibility = 'collapse';
                }
            }
        } else if (moves > (nCards * 0.75)) {
            for (var i = 0; i < 3; i++) {
                if (i > 0) {
                    stars[i].style.visibility = 'collapse';
                }
            }
        }
    }

    function startTimer() {
        interval = setInterval(function() {
            timer.innerHTML = minutes + ' ' + minutesText + ' ' + seconds + ' ' + secondsText;
            seconds++;
            if (seconds == 60) {
                minutes++;
                seconds = 0;
            }
        }, 1000);
    }

    function congratulations() {
        if (matchedCard.length == nCards) {
            clearInterval(interval);
            var finalTime = timer.innerHTML;

            // show modal
            modal.classList.add('show');

            var starRating = document.getElementById('stars').innerHTML;

            // showing moves, rating and time on modal
            document.getElementById('final-move').innerHTML = moves;
            document.getElementById('star-rating').innerHTML = starRating;
            document.getElementById('total-time').innerHTML = finalTime;

            // close icon on modal
            closeModal();
        }
    }

    function closeModal() {
        closeIcon.addEventListener('click', function() {
            modal.classList.remove('show');
            document.getElementById('star-rating').innerHTML = '';
            // start the slider again
            console.log('Starting slider');            
            $('#slider').carousel('cycle');
        }, false);
    }
    /* jshint ignore:end */

    // Fisher-Yates (aka Knuth) Shuffle
    function shuffle(array) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        while (currentIndex !== 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    }

    document.body.onload = startGame(false);
})(jQuery);
